module.exports = __webpack_public_path__ + "img/s2.b484ec6.png";